'use client';

import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';

/**
 * Versión de `isMobile` segura para hidratación.
 *
 * `isMobile` de react-device-detect se calcula leyendo `navigator.userAgent`,
 * que no existe en el servidor: durante el SSR vale siempre `false`. Usarlo
 * directamente en un componente que se renderiza en servidor hace que el HTML
 * del servidor y el del cliente no coincidan y React tire toda la página para
 * volver a pintarla en cliente (errores #418/#423/#425).
 *
 * Este hook devuelve `false` en el servidor y en el primer render del cliente
 * —así ambos coinciden— y pasa al valor real justo después de hidratar.
 *
 * Si el componente se renderiza en servidor, es preferible que el padre
 * (un Server Component) calcule `isMobileSSR()` y lo pase por props: así el
 * HTML ya sale correcto desde el servidor y no hay salto visual.
 */
export function useIsMobileDevice() {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    setIsMobileDevice(isMobile);
  }, []);

  return isMobileDevice;
}
